__turbopack_context__.v({
  "bottomSheet": "XzKdlG_bottomSheet",
  "bvMedia": "XzKdlG_bvMedia",
  "pricing": "XzKdlG_pricing",
  "root": "XzKdlG_root",
  "specBlock": "XzKdlG_specBlock",
});
